import { Button } from '@mui/material'
import asset from 'json/assets'
import React from 'react'
import styles from "styles/component/ProfileSidebar.module.scss"

const ProfileSidebar = () => {
  return (
    <div className={styles.sidebar_list}>
        <ul>
          <li>
            <Button>
              <span className={styles.icon}>
                <img src={asset.gen_settings} alt="" />
              </span>
              <span>General Settings</span>
            </Button>
          </li>
          <li>
            <Button>
              <span className={styles.icon}>
                <img src={asset.asset_tracker} alt="" />
              </span>
         
              <span>Asset Tracker</span>
            </Button>
          </li>
          <li>
            <Button>
              <span className={styles.icon}>
                <img src={asset.admin_privileges} alt="" />
              </span>
        
              <span>Admin Privileges</span>
            </Button>
          </li>
          <li>
            <Button>
              <span className={styles.icon}>
                <img src={asset.printers_terms} alt="" />
              </span>
          
              <span>Printers & Terminals</span>
            </Button>
          </li>
        </ul>
      </div>
  )
}

export default ProfileSidebar